import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { 
  FaLinkedinIn, FaTwitter, FaInstagram, FaYoutube, 
  FaArrowUp, FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaWhatsapp
} from 'react-icons/fa';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const footerLinks = {
    'Quick Links': [
      { name: 'Home', path: '/' },
      { name: 'About Us', path: '/about' },
      { name: 'Solutions', path: '/solutions' },
      { name: 'Products', path: '/products' },
      { name: 'Contact', path: '/contact' },
    ],
    'Solutions': [
      { name: 'CRM Solutions', path: '/solutions' },
      { name: 'Salesforce Services', path: '/solutions' },
      { name: 'AI Automation', path: '/solutions' },
      { name: 'Custom Development', path: '/solutions' },
      { name: 'Integrations', path: '/solutions' },
    ],
    'Resources': [
      { name: 'Documentation', path: '/contact' },
      { name: 'API Reference', path: '/contact' },
      { name: 'Support Center', path: '/contact' },
      { name: 'Training', path: '/contact' },
      { name: 'Blog', path: '/contact' },
    ],
  };

  return (
    <footer className="relative bg-primary-950 border-t border-accent/10">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-accent/30 to-transparent" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="py-16">
          <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-8 mb-12">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
              className="lg:col-span-2"
            >
              <Link to="/" className="flex items-center space-x-2 sm:space-x-3 mb-6">
                <img
                  src="/images/Logo Sronzer Short.png"
                  alt="Sronzer Logo"
                  className="w-12 h-12 md:w-14 md:h-14 object-contain"
                />
                <div>
                  <h2 className="text-sm md:text-lg font-display font-bold tracking-wider text-white leading-none">
                    SRONZER<span className="text-accent"> Private Limited</span>
                  </h2>
                  <p className="text-[8px] md:text-[10px] text-gray-400 tracking-[0.2em] mt-0.5">CRM SOLUTIONS</p>
                </div>
              </Link>
              
              <p className="text-gray-400 text-sm leading-relaxed mb-6">
                Empowering businesses with enterprise CRM solutions, Salesforce expertise, 
                and AI-powered automation since 2025.
              </p>

              <div className="space-y-3 mb-6">
                <a href="tel:+919277128460" className="flex items-center space-x-3 text-gray-400 hover:text-accent transition-colors">
                  <FaPhoneAlt className="text-xs text-accent" />
                  <span className="text-sm">+91 -9277128460</span>
                </a>
                <a href="https://wa.me/919277128460" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-3 text-gray-400 hover:text-green-400 transition-colors">
                  <FaWhatsapp className="text-xs text-green-500" />
                  <span className="text-sm">+91 -9277128460 (WhatsApp)</span>
                </a>
                <a href="mailto:connect@sronzer.com" className="flex items-center space-x-3 text-gray-400 hover:text-accent transition-colors">
                  <FaEnvelope className="text-xs text-accent" />
                  <span className="text-sm">connect@sronzer.com</span>
                </a>
                <div className="flex items-start space-x-3 text-gray-400">
                  <FaMapMarkerAlt className="text-xs text-accent mt-1" />
                  <span className="text-sm">
                    36/1 mauza karamjeetpur pargana varanas 221005, India
                  </span>
                </div>
              </div>
<div className="flex space-x-3">
  {[
    { icon: FaLinkedinIn, href: 'https://www.linkedin.com/in/sronzer-team-0081793ab/' },
    { icon: FaInstagram, href: 'https://www.instagram.com/sronzer/' },
    { icon: FaLinkedinIn, href: 'https://www.linkedin.com/company/sronzer/posts/?feedView=all' },
    // { icon: FaTwitter, href: '#' },
    // { icon: FaYoutube, href: '#' },
  ].map((social, idx) => (
    <motion.a
      key={idx}
      href={social.href}
      whileHover={{ y: -3 }}
      className="w-9 h-9 bg-primary-800/50 border border-gray-700 rounded-full 
               flex items-center justify-center text-gray-400 hover:text-accent 
               hover:border-accent/50 transition-all duration-300"
      target="_blank"
      rel="noopener noreferrer"
    >
      <social.icon className="text-xs" />
    </motion.a>
  ))}
</div>
            </motion.div>

            {Object.entries(footerLinks).map(([title, links], colIndex) => (
              <motion.div
                key={title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: colIndex * 0.1 }}
                viewport={{ once: true }}
              >
                <h3 className="text-white font-display font-bold text-sm mb-4 tracking-wider">
                  {title.toUpperCase()}
                </h3>
                <ul className="space-y-2.5">
                  {links.map((link, index) => (
                    <li key={index}>
                      <Link
                        to={link.path}
                        className="text-gray-400 text-sm hover:text-accent transition-colors duration-300
                                 hover:translate-x-1 inline-block transform"
                      >
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </motion.div>
            ))}
          </div>

          <div className="pt-8 border-t border-gray-800">
            <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
              <p className="text-gray-500 text-xs">
                © {new Date().getFullYear()} Sronzer Technologies. All rights reserved. | 
                <Link to="/privacy" className="hover:text-accent transition-colors ml-1">Privacy Policy</Link> | 
                <Link to="/terms" className="hover:text-accent transition-colors ml-1">Terms of Service</Link>
              </p>

              <motion.button
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                onClick={scrollToTop}
                className="w-10 h-10 bg-accent/10 border border-accent/30 rounded-full 
                         flex items-center justify-center text-accent hover:bg-accent/20 
                         transition-all duration-300"
              >
                <FaArrowUp />
              </motion.button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;